import { z } from 'zod';

const envShape = z.union([z.literal('development'), z.literal('staging'), z.literal('production')]);

export type Environment = z.infer<typeof envShape>;
export const environment = envShape.parse(process.env.NEXT_PUBLIC_ENVIRONMENT);

export const IS_PRODUCTION = environment === 'production';
export const IS_STAGING = environment === 'staging';

export const STAGING_USERNAME = process.env.STAGING_USERNAME || '';
export const STAGING_PASSWORD = process.env.STAGING_PASSWORD || '';

export const IS_TEST = process.env.JEST_WORKER_ID !== undefined;

export const ENCRYPTION_KEY = process.env.ENCRYPTION_KEY || '';

export const PROD_DOMAIN = 'galatea.com';

export const PODCAST_COUPON = environment === 'production' ? 'iXxrBsyU' : 'qEg9TRhP';

/** TODO: remove once we've fully migrated to web 2 and we're no longer proxy-ing to 2.galatea.com */
export const PROD_DOMAIN_2 = '2.galatea.com';

export const PROD_DOMAIN_WITH_PROTOCOL = `https://${PROD_DOMAIN}`;

export const IS_DEV = process.env.NODE_ENV === 'development';

export const SATURN_API_BASE =
  process.env.OVERRIDE_SATURN_ENDPOINT || process.env.SATURN_API_BASE || 'http://127.0.0.1:3000';

export const VERSION = process.env.NEXT_PUBLIC_VERSION || '0.0.0';

export const getBaseUrl = () => {
  return IS_DEV ? 'http://localhost:4200' : IS_PRODUCTION ? 'https://galatea.com' : 'https://staging.galatea.com';
};
